"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// `drafts.foo-bar` => `foo.bar`
function unprefixDraftId(id) {
    return id.replace(/^drafts\./, '');
}
exports.unprefixDraftId = unprefixDraftId;
//# sourceMappingURL=unprefixDraftId.js.map